/* Wunderlich Mahlgrad <-> Variant-Picker Sync v2
   Korrigierte Selektoren — Theme nutzt name="{OptionName}-{position}" Format, nicht options[Name]
*/
(function(){
  'use strict';

  function findMahlgradRadios(){
    return document.querySelectorAll('input[type="radio"][name^="Mahlgrad-"]');
  }

  function findMahlgradRadioByValue(grindLabel){
    var radios = findMahlgradRadios();
    for(var i=0;i<radios.length;i++){
      if(radios[i].value === grindLabel) return radios[i];
    }
    return null;
  }

  function syncMahlgradTileToVariant(tile){
    var labelEl = tile.querySelector('.wr-mg-label');
    if(!labelEl) return;
    var grindLabel = labelEl.textContent.trim();
    var radio = findMahlgradRadioByValue(grindLabel);
    if(!radio) { console.warn('[wr-mahlgrad-sync] No radio found for', grindLabel); return; }
    if(radio.checked) return;
    radio.checked = true;
    /* Try multiple event types for variant-picker to pick up the change */
    radio.dispatchEvent(new Event('change', {bubbles:true, cancelable:true}));
    radio.dispatchEvent(new Event('input',  {bubbles:true, cancelable:true}));
    /* Also dispatch a synthetic click on the associated label as fallback */
    var label = document.querySelector('label[for="'+radio.id+'"]');
    if(label){ label.click(); }
  }

  function syncTilesFromVariantState(){
    var radios = findMahlgradRadios();
    var checked = null;
    for(var i=0;i<radios.length;i++){
      if(radios[i].checked){ checked = radios[i]; break; }
    }
    if(!checked) return;
    var label = checked.value;
    document.querySelectorAll('.wr-mg-item').forEach(function(tile){
      var l = tile.querySelector('.wr-mg-label');
      if(!l) return;
      if(l.textContent.trim() === label){
        tile.classList.add('is-selected');
      } else {
        tile.classList.remove('is-selected');
      }
    });
  }

  function wireTiles(){
    document.querySelectorAll('.wr-mg-item').forEach(function(tile){
      if(tile.dataset.wrMahlgradWired === '1') return;
      tile.dataset.wrMahlgradWired = '1';
      tile.addEventListener('click', function(){
        syncMahlgradTileToVariant(tile);
      });
    });
  }

  function observeVariantChanges(){
    findMahlgradRadios().forEach(function(radio){
      if(radio.dataset.wrObserved === '1') return;
      radio.dataset.wrObserved = '1';
      radio.addEventListener('change', syncTilesFromVariantState);
    });
  }

  function init(){
    wireTiles();
    observeVariantChanges();
    syncTilesFromVariantState();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
  setTimeout(init, 3000);
})();
